module.exports = function(app) {
    "use strict";
    app.controller('pages.assistEmployees.preventiveMedications', ["$state", "$scope", "sessionData", "services", "$window",
        function ($state, $scope, sessionData, services, $window) {

            $scope.sidebar = {
                breadCrumb : {
                    primary : {
                        title: "Assist Employees",
                        state: "assistEmployees"
                    },
                    secondary : {
                        title: "Preventive Medications List"
                    }
                }
            };
            $scope.objFiltering = {
                orderBy: 'planName',
                reverse: false,
                titles: [
                    {
                        name: "Name",
                        dataKey: "planName"
                    }
                ],
                arrItems: []
            }
            $scope.feedback = {};

            $scope.sessionData = sessionData;
        } ] );
        // ========================================================
        //  the routes object:  return [ ] ,  is in assistEmployees
        //  and the svc request is in filterBoxAndTableDisplay
        // ========================================================
};

